import { Pagination } from "../../types/common";

// Legacy JobMatcher types
export type JobMatcher = {
    query: string;
    sortBy: string;
    filter: any;
    pagination: Pagination;
};

export interface JobOfferMatchType {
    query: string;
    sortBy: string;
    filter: Filter;
    pagination: PaginationType;
}

export interface Filter {
    contract: Contract;
    position: Position;
    candidate: Candidate;
    city: string;
    postal: string;
}

export interface Candidate {
    specialties: string[];
}

export interface Contract {
    remuneration: Remuneration;
    contractType: string;
}

export interface Remuneration {
    min: number;
    max: number;
}

export interface Position {
    professions: string[];
}

export interface PaginationType {
    offset: number;
    limit: number;
}

// New polymorphic assignee types
export enum AssigneeType {
    OrganizationUser = 'OrganizationUser',
    Pro = 'Pro'
}

export interface AssigneeInput {
    _id: string;
    assigneeType: AssigneeType;
}

export interface OrganizationUserDetails {
    _id: string;
    color?: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    file?: {
        _id: string;
        name: string;
        url: string;
    }[];
}

export interface ProDetails {
    _id: string;
    email: string;
    bossFirstname?: string;
    bossLastname?: string;
    bossPhoto?: string;
    commercialName: string;
    role: string;
}

export type AssigneeDetails = OrganizationUserDetails | ProDetails;

export interface JobOfferAssignee {
    _id: string;
    assigneeType: AssigneeType;
    role: string;
    assignedAt: string;
    assigneeDetails: AssigneeDetails;
    assignedBy?: AssigneeDetails;
}

// Helper type for legacy format conversion
export interface LegacyAssignee {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    assigneeType?: AssigneeType;
    color?: string;
    file?: {
        _id: string;
        name: string;
        url: string;
    }[];
}
